import {
  Button,
  Divider,
  Grid,
  List,
  ListItem,
  Paper,
  Typography,
  Container,
} from "@material-ui/core";
import _ from "lodash";
import React, { useEffect } from "react";

import { useStore } from "../store/Store";
import {
  getFilters,
  deleteKeyword,
  updateKeywords,
  insertNewKeywordCategory,
  insertNewKeyword,
} from "../restAPI/v1/filters";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";

interface State {
  selectedKeywordCategory: System.keywordCategory | undefined;
  keywords: System.keywordCategory[];
}

const ManageKeywords = (props: any) => {
  const [localState, setLocalState] = React.useState<State>({
    selectedKeywordCategory: undefined,
    keywords: [],
  });
  const keywordCategoryListRef = React.createRef<HTMLDivElement>();
  const keywordRef = React.createRef<HTMLDivElement>();

  const { dispatch, state } = useStore();

  useEffect(() => {
    getFilters().then((keywords) => {
      setLocalState({
        ...localState,
        keywords: keywords,
        selectedKeywordCategory: keywords[0],
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      keywordRef &&
      keywordRef.current &&
      keywordCategoryListRef &&
      keywordCategoryListRef.current
    ) {
      keywordCategoryListRef.current.scrollTo(0, keywordRef.current.offsetTop);
    }
  }, [keywordRef, keywordCategoryListRef]);

  const handleRemoveKeyword = (id: any) => {
    deleteKeyword(id).then(() => {
      if (!localState.selectedKeywordCategory) {
        return;
      }
      props.populateFilters();

      let duplicateKeywords = localState.keywords;
      let index = duplicateKeywords.findIndex(
        (obj) => obj.id === localState.selectedKeywordCategory?.id
      );
      duplicateKeywords[index].tags_models = duplicateKeywords[
        index
      ].tags_models.filter((tag) => tag.id !== id);

      setLocalState({
        ...localState,
        keywords: duplicateKeywords,
        selectedKeywordCategory: duplicateKeywords[index],
      });
    });
  };

  const handleInputChangeKeywordCategory = (event: any) => {
    if (!localState.selectedKeywordCategory) {
      return;
    }
    setLocalState({
      ...localState,
      selectedKeywordCategory: {
        ...localState.selectedKeywordCategory,
        [event.target.name]: event.target.value,
      },
    });
  };

  const handleInputChangeKeyword = (id: number, event: any) => {
    if (!localState.selectedKeywordCategory) {
      return;
    }

    let tag_models = localState.selectedKeywordCategory.tags_models;
    const index = _.findIndex(tag_models, { id: id });
    tag_models[index].name = event.target.value;

    setLocalState({
      ...localState,
      selectedKeywordCategory: {
        ...localState.selectedKeywordCategory,
        tags_models: tag_models,
      },
    });
  };

  const handleUpdateKeyword = () => {
    if (!localState.selectedKeywordCategory) {
      return;
    }
    updateKeywords(localState.selectedKeywordCategory).then((res) => {
      props.populateFilters();
      dispatch({
        type: "SET_MODAL_PROPS",
        modalProps: {
          open: true,
          title: "Keywords updated",
          btn1Text: "",
          btn1Color: "primary",
          btn2Text: "Close",
          btn2Color: "default",
          text: "Keywords were updated successfully",
          shouldRedirect: false,
          btn1OnClick: async (inputs: System.ModalInputs) => {},
        },
      });
    });
  };

  const addKeywordCategory = async () => {
    props.populateFilters();
    dispatch({
      type: "SET_MODAL_PROPS",
      modalProps: {
        open: true,
        title: "Add keyword category",
        btn1Text: "Create",
        btn1Color: "primary",
        btn2Text: "Cancel",
        btn2Color: "default",
        text: "",
        shouldRedirect: false,
        btn1OnClick: async (inputs: System.ModalInputs) => {
          const newKeyword: System.keywordCategory = {
            createdat: null,
            name: inputs.name.value,
            id: 1,
            tags_models: [],
          };

          insertNewKeywordCategory(newKeyword.name).then((res) => {
            //pushing inserted item to state
            let newKeywords = localState.keywords;
            res.data.tags_models = [];
            newKeywords.push(res.data);
            newKeywords.sort((a, b) => a.name.localeCompare(b.name));
            setLocalState({
              ...localState,
              keywords: newKeywords,
              selectedKeywordCategory: res.data,
            });
          });
        },
        inputs: {
          name: {
            type: "text",
            label: "Name",
            value: "",
          },
        },
      },
    });
  };

  const addNewKeyword = async () => {
    props.populateFilters();
    dispatch({
      type: "SET_MODAL_PROPS",
      modalProps: {
        open: true,
        title: "Add keyword",
        btn1Text: "Create",
        btn1Color: "primary",
        btn2Text: "Cancel",
        btn2Color: "default",
        text: "",
        shouldRedirect: false,
        btn1OnClick: async (inputs: System.ModalInputs) => {
          if (!localState.selectedKeywordCategory) {
            return;
          }
          insertNewKeyword(
            inputs.name.value,
            localState.selectedKeywordCategory.id
          ).then((res) => {
            let newTagsModels = localState.selectedKeywordCategory?.tags_models;
            newTagsModels && newTagsModels.push(res.data);
            newTagsModels &&
              localState.selectedKeywordCategory &&
              setLocalState({
                ...localState,
                selectedKeywordCategory: {
                  ...localState.selectedKeywordCategory,
                  tags_models: newTagsModels,
                },
              });
          });
        },
        inputs: {
          name: {
            type: "text",
            label: "Name",
            value: "",
          },
        },
      },
    });
  };

  if (!state.user.isAdmin && !state.processingCookie) {
    window.location.href = "/";
  }

  return (
    <>
      {state.processingCookie === true ? (
        <>Loading...</>
      ) : (
        <>
          {state.user.isAdmin && (
            <Container>
              <h2 style={{ marginTop: "0.5em" }}>
                <span className="primary-color"> Manage</span>
                <span className="secondary-color"> Keywords </span>
              </h2>
              <Typography>
                <span style={{ color: "black" }}>
                  Select a keyword category from the list to add, edit or delete
                  keywords. You can also create a new keywords category and add
                  keywords to it.
                </span>
              </Typography>

              <Paper
                elevation={2}
                style={{ marginTop: "1em", marginBottom: "3em" }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={12} style={{ padding: "0.5em 1.5em" }}>
                    <Typography
                      style={{ display: "flex" }}
                      className={"heading"}
                    >
                      All keyword categories
                      <Button
                        style={{
                          marginLeft: "auto",
                        }}
                        size="small"
                        variant="contained"
                        onClick={() => {
                          addKeywordCategory();
                        }}
                      >
                        New
                      </Button>
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <List
                      component="nav"
                      className="settings-list"
                      ref={keywordCategoryListRef}
                    >
                      {localState.keywords.map((keywordCategory) => (
                        <ListItem
                          selected={
                            keywordCategory.id ===
                            localState.selectedKeywordCategory?.id
                          }
                          ref={
                            keywordCategory.id ===
                            localState.selectedKeywordCategory?.id
                              ? keywordRef
                              : null
                          }
                          button
                          key={keywordCategory.id}
                          onClick={() =>
                            setLocalState({
                              ...localState,
                              selectedKeywordCategory: keywordCategory,
                            })
                          }
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <div>{keywordCategory.name}</div>
                            <div style={{ color: "#aaa" }}>
                              {keywordCategory.tags_models.length}
                            </div>
                          </div>
                        </ListItem>
                      ))}
                    </List>
                  </Grid>
                  <Grid item xs={12} sm={6} style={{ padding: "1em" }}>
                    <List component="nav" className="settings-list">
                      {!localState.selectedKeywordCategory ? (
                        <Typography
                          className={"heading"}
                          style={{ margin: "1em" }}
                        >
                          No category selected
                        </Typography>
                      ) : (
                        <ValidatorForm
                          className="settings-flex-column"
                          onSubmit={() => {
                            console.log("onSubmit clicked");
                          }}
                        >
                          <TextValidator
                            style={{ marginBottom: "1em", width: "100%" }}
                            value={localState.selectedKeywordCategory?.name}
                            name="name"
                            label="Keyword category name"
                            onChange={(event) =>
                              handleInputChangeKeywordCategory(event)
                            }
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                            variant="outlined"
                          />
                          <Typography className={"heading"}>
                            Keywords
                          </Typography>

                          <div style={{ marginBottom: "1em" }}></div>
                          {localState.selectedKeywordCategory.tags_models.map(
                            (keyword) => (
                              <div key={keyword.id}>
                                <Grid container>
                                  <Grid item xs={10}>
                                    <TextValidator
                                      style={{
                                        marginBottom: "1em",
                                        width: "100%",
                                      }}
                                      value={keyword.name}
                                      name="name"
                                      required
                                      onChange={(event) =>
                                        handleInputChangeKeyword(
                                          keyword.id,
                                          event
                                        )
                                      }
                                      validators={["required"]}
                                      errorMessages={["This field is required"]}
                                      variant="outlined"
                                    />
                                  </Grid>
                                  <Grid item xs={2}>
                                    <Button
                                      style={{
                                        width: "35px",
                                        marginLeft: "10px",
                                        marginTop: "9px",
                                      }}
                                      onClick={() => {
                                        handleRemoveKeyword(keyword.id);
                                      }}
                                      color="secondary"
                                      variant="contained"
                                    >
                                      Remove
                                    </Button>
                                  </Grid>
                                </Grid>
                              </div>
                            )
                          )}
                        </ValidatorForm>
                      )}
                    </List>
                    <Grid container style={{ paddingTop: "1em" }}>
                      <Grid item xs={12} style={{ paddingBottom: "0.4em" }}>
                        <Divider />
                      </Grid>
                      <Grid item sm={7} xs={12}></Grid>
                      <Grid item xs={6} sm={3}>
                        <Button
                          style={{
                            width: "fit-content",
                          }}
                          onClick={() => {
                            addNewKeyword();
                          }}
                          color="primary"
                          variant="contained"
                        >
                          Add new keyword
                        </Button>
                      </Grid>
                      <Grid item xs={4} sm={2}>
                        <Button
                          style={{
                            width: "fit-content",
                          }}
                          onClick={() => {
                            console.log("update keywords clicked");
                            handleUpdateKeyword();
                          }}
                          variant="contained"
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Container>
          )}
        </>
      )}
    </>
  );
};

export default ManageKeywords;
